export type LabelsStateKey =
  | "lowerLetter"
  | "oneNumber"
  | "uppercaseLetter"
  | "charactersMin";

export type PasswordValidatorLabel = {
  copy: string;
  validator: LabelsStateKey;
};

export type PasswordValidatorLabels = PasswordValidatorLabel[];

export const passwordValidatorLabels: PasswordValidatorLabels = [
  {
    copy: "One lowercase letter",
    validator: "lowerLetter",
  },
  {
    copy: "One uppercase letter",
    validator: "uppercaseLetter",
  },
  {
    copy: "One number",
    validator: "oneNumber",
  },
  {
    copy: "8 characters min",
    validator: "charactersMin",
  },
];
